import { render, staticRenderFns } from "./NavigationDrawerListGroupCommodity.vue?vue&type=template&id=a099ca3a"
import script from "./NavigationDrawerListGroupCommodity.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawerListGroupCommodity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports